import B, { isValidElement as L, cloneElement as V, createElement as H } from "react";
import _ from "../../../../_virtual/isNil.js";
import N from "../../../../_virtual/isFunction.js";
import D from "../../../../_virtual/isObject.js";
import { clsx as z } from "../../../clsx/dist/clsx.js";
import { Text as q } from "./Text.js";
import { filterProps as F, findAllByType as K } from "../util/ReactUtils.js";
import { isNumber as A, uniqueId as U, isPercent as M, getPercentValue as W, mathSign as G, isNumOrStr as J } from "../util/DataUtils.js";
import { polarToCartesian as T } from "../util/PolarUtils.js";
function E(t) {
  "@babel/helpers - typeof";
  return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, E(t);
}
var Q = ["offset"];
function X(t) {
  return te(t) || ee(t) || Z(t) || Y();
}
function Y() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z(t, e) {
  if (t) {
    if (typeof t == "string") return k(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return k(t, e);
  }
}
function ee(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function te(t) {
  if (Array.isArray(t)) return k(t);
}
function k(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function re(t, e) {
  if (t == null) return {};
  var r = ne(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      n = a[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function ne(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function I(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function v(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? I(Object(r), !0).forEach(function(n) {
      ie(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : I(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ie(t, e, r) {
  return e = ae(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ae(t) {
  var e = oe(t, "string");
  return E(e) == "symbol" ? e : e + "";
}
function oe(t, e) {
  if (E(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (E(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function R() {
  return R = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, R.apply(this, arguments);
}
var le = function(e) {
  var r = e.value, n = e.formatter, i = _(e.children) ? r : e.children;
  return N(n) ? n(i) : i;
}, ce = function(e, r) {
  var n = G(r - e), i = Math.min(Math.abs(r - e), 360);
  return n * i;
}, ue = function(e, r, n) {
  var i = e.position, a = e.viewBox, f = e.offset, c = e.className, o = a, l = o.cx, u = o.cy, x = o.innerRadius, h = o.outerRadius, s = o.startAngle, m = o.endAngle, y = o.clockWise, d = (x + h) / 2, b = ce(s, m), g = b >= 0 ? 1 : -1, P, w;
  i === "insideStart" ? (P = s + g * f, w = y) : i === "insideEnd" ? (P = m - g * f, w = !y) : i === "end" && (P = m + g * f, w = y), w = b <= 0 ? w : !w;
  var j = T(l, u, d, P), S = T(l, u, d, P + (w ? 1 : -1) * 359), p = "M".concat(j.x, ",").concat(j.y, `
    A`).concat(d, ",").concat(d, ",0,1,").concat(w ? 0 : 1, `,
    `).concat(S.x, ",").concat(S.y), C = _(e.id) ? U("recharts-radial-line-") : e.id;
  return /* @__PURE__ */ B.createElement("text", R({}, n, {
    dominantBaseline: "central",
    className: z("recharts-radial-bar-label", c)
  }), /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("path", {
    id: C,
    d: p
  })), /* @__PURE__ */ B.createElement("textPath", {
    xlinkHref: "#".concat(C)
  }, r));
}, fe = function(e) {
  var r = e.viewBox, n = e.offset, i = e.position, a = r, f = a.cx, c = a.cy, o = a.innerRadius, l = a.outerRadius, u = a.startAngle, x = a.endAngle, h = (u + x) / 2;
  if (i === "outside") {
    var s = T(f, c, l + n, h), m = s.x, y = s.y;
    return {
      x: m,
      y,
      textAnchor: m >= f ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: f,
      y: c,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: f,
      y: c,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: f,
      y: c,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var d = (o + l) / 2, b = T(f, c, d, h), g = b.x, P = b.y;
  return {
    x: g,
    y: P,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, de = function(e) {
  var r = e.viewBox, n = e.parentViewBox, i = e.offset, a = e.position, f = r, c = f.x, o = f.y, l = f.width, u = f.height, x = u >= 0 ? 1 : -1, h = x * i, s = x > 0 ? "end" : "start", m = x > 0 ? "start" : "end", y = l >= 0 ? 1 : -1, d = y * i, b = y > 0 ? "end" : "start", g = y > 0 ? "start" : "end";
  if (a === "top") {
    var P = {
      x: c + l / 2,
      y: o - x * i,
      textAnchor: "middle",
      verticalAnchor: s
    };
    return v(v({}, P), n ? {
      height: Math.max(o - n.y, 0),
      width: l
    } : {});
  }
  if (a === "bottom") {
    var w = {
      x: c + l / 2,
      y: o + u + h,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return v(v({}, w), n ? {
      height: Math.max(n.y + n.height - (o + u), 0),
      width: l
    } : {});
  }
  if (a === "left") {
    var j = {
      x: c - d,
      y: o + u / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return v(v({}, j), n ? {
      width: Math.max(j.x - n.x, 0),
      height: u
    } : {});
  }
  if (a === "right") {
    var S = {
      x: c + l + d,
      y: o + u / 2,
      textAnchor: g,
      verticalAnchor: "middle"
    };
    return v(v({}, S), n ? {
      width: Math.max(n.x + n.width - S.x, 0),
      height: u
    } : {});
  }
  var p = n ? {
    width: l,
    height: u
  } : {};
  return a === "insideLeft" ? v({
    x: c + d,
    y: o + u / 2,
    textAnchor: g,
    verticalAnchor: "middle"
  }, p) : a === "insideRight" ? v({
    x: c + l - d,
    y: o + u / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, p) : a === "insideTop" ? v({
    x: c + l / 2,
    y: o + h,
    textAnchor: "middle",
    verticalAnchor: m
  }, p) : a === "insideBottom" ? v({
    x: c + l / 2,
    y: o + u - h,
    textAnchor: "middle",
    verticalAnchor: s
  }, p) : a === "insideTopLeft" ? v({
    x: c + d,
    y: o + h,
    textAnchor: g,
    verticalAnchor: m
  }, p) : a === "insideTopRight" ? v({
    x: c + l - d,
    y: o + h,
    textAnchor: b,
    verticalAnchor: m
  }, p) : a === "insideBottomLeft" ? v({
    x: c + d,
    y: o + u - h,
    textAnchor: g,
    verticalAnchor: s
  }, p) : a === "insideBottomRight" ? v({
    x: c + l - d,
    y: o + u - h,
    textAnchor: b,
    verticalAnchor: s
  }, p) : D(a) && (A(a.x) || M(a.x)) && (A(a.y) || M(a.y)) ? v({
    x: c + W(a.x, l),
    y: o + W(a.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, p) : v({
    x: c + l / 2,
    y: o + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, p);
}, se = function(e) {
  return "cx" in e && A(e.cx);
};
function O(t) {
  var e = t.offset, r = e === void 0 ? 5 : e, n = re(t, Q), i = v({
    offset: r
  }, n), a = i.viewBox, f = i.position, c = i.value, o = i.children, l = i.content, u = i.className, x = u === void 0 ? "" : u, h = i.textBreakAll;
  if (!a || _(c) && _(o) && !/* @__PURE__ */ L(l) && !N(l))
    return null;
  if (/* @__PURE__ */ L(l))
    return /* @__PURE__ */ V(l, i);
  var s;
  if (N(l)) {
    if (s = /* @__PURE__ */ H(l, i), /* @__PURE__ */ L(s))
      return s;
  } else
    s = le(i);
  var m = se(a), y = F(i, !0);
  if (m && (f === "insideStart" || f === "insideEnd" || f === "end"))
    return ue(i, s, y);
  var d = m ? fe(i) : de(i);
  return /* @__PURE__ */ B.createElement(q, R({
    className: z("recharts-label", x)
  }, y, d, {
    breakAll: h
  }), s);
}
O.displayName = "Label";
var $ = function(e) {
  var r = e.cx, n = e.cy, i = e.angle, a = e.startAngle, f = e.endAngle, c = e.r, o = e.radius, l = e.innerRadius, u = e.outerRadius, x = e.x, h = e.y, s = e.top, m = e.left, y = e.width, d = e.height, b = e.clockWise, g = e.labelViewBox;
  if (g)
    return g;
  if (A(y) && A(d)) {
    if (A(x) && A(h))
      return {
        x,
        y: h,
        width: y,
        height: d
      };
    if (A(s) && A(m))
      return {
        x: s,
        y: m,
        width: y,
        height: d
      };
  }
  return A(x) && A(h) ? {
    x,
    y: h,
    width: 0,
    height: 0
  } : A(r) && A(n) ? {
    cx: r,
    cy: n,
    startAngle: a || i || 0,
    endAngle: f || i || 0,
    innerRadius: l || 0,
    outerRadius: u || o || c || 0,
    clockWise: b
  } : e.viewBox ? e.viewBox : {};
}, he = function(e, r) {
  return e ? e === !0 ? /* @__PURE__ */ B.createElement(O, {
    key: "label-implicit",
    viewBox: r
  }) : J(e) ? /* @__PURE__ */ B.createElement(O, {
    key: "label-implicit",
    viewBox: r,
    value: e
  }) : /* @__PURE__ */ L(e) ? e.type === O ? /* @__PURE__ */ V(e, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ B.createElement(O, {
    key: "label-implicit",
    content: e,
    viewBox: r
  }) : N(e) ? /* @__PURE__ */ B.createElement(O, {
    key: "label-implicit",
    content: e,
    viewBox: r
  }) : D(e) ? /* @__PURE__ */ B.createElement(O, R({
    viewBox: r
  }, e, {
    key: "label-implicit"
  })) : null : null;
}, ve = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var i = e.children, a = $(e), f = K(i, O).map(function(o, l) {
    return /* @__PURE__ */ V(o, {
      viewBox: r || a,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(l)
    });
  });
  if (!n)
    return f;
  var c = he(e.label, r || a);
  return [c].concat(X(f));
};
O.parseViewBox = $;
O.renderCallByParent = ve;
export {
  O as Label
};
